import { useRef, useState } from 'react';

import { qrcodeAPIService } from '~/api/qrcode';
import { useAppDispatch } from '~/hooks/useRedux';
import { updateQrCodeThunk } from '~/store/reducers/qr-code';
import useUrlValidationStore from '~/store/useUrlValidationStore';

export const useQRUrlValidation = (url) => {
  const dispatch = useAppDispatch();
  const [errorMessage, setErrorMessage] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const { setIsPending } = useUrlValidationStore();

  const resetErrorMessage = () => setErrorMessage(null);

  const abortController = useRef(null);

  const cancelUrlValidationRequest = () => {
    const controller = abortController.current;

    if (controller) {
      controller.abort();
    }
  };

  const sendUrl = async () => {
    setErrorMessage(null);
    setIsProcessing(true);
    setIsPending(true);
    try {
      if (abortController.current) {
        cancelUrlValidationRequest();
      }
      abortController.current = new AbortController();

      const response = await qrcodeAPIService.getUriValidation(url, abortController.current.signal);
      if (response.data && response.data.success) {
        setErrorMessage(null);
        await dispatch(updateQrCodeThunk({ uri: url }));
      }
    } catch (error) {
      const message = error?.code === 'ERR_CANCELED' ? null : error?.message;
      setErrorMessage(message);
    }

    setIsProcessing(false);
    abortController.current = null;
    setIsPending(false);
  };

  return {
    sendUrl,
    cancelUrlValidationRequest,
    errorMessage,
    resetErrorMessage,
    isProcessing,
  };
};
